const shouldShowTestProcedureForm = ({ scheduleEvents }) => {
  return !scheduleEvents.some(
    (e) => e.type === "TEST_PROCEDURE" && e.attended !== false
  );
};

const shouldShowProcedureForm = ({ scheduleEvents, numberEvents }) => {
  const attendedProcedures = scheduleEvents.filter(
    (e) => e.type === "PROCEDURE" && e.attended !== false
  ).length;
  return attendedProcedures < numberEvents;
};

export const rulesForTPatientSurgeryProcedure = {
  HYPERBARIC_FLOW_NOX: {
    "NO RED FLAG": {
      QUIZ_ANSWERED: {
        type: "TEST_PROCEDURE",
        showForm: shouldShowTestProcedureForm,
      },
      ASSESSMENT_MADE: {
        type: "PROCEDURE",
        showForm: shouldShowProcedureForm,
      },
    },
    "RED FLAG": {
      ASSESSMENT_MADE: {
        type: "PROCEDURE",
        showForm: shouldShowProcedureForm,
      },
    },
  },
  CORE_NOX: {
    "FAST TRACK": {
      ASSESSMENT_MADE: {
        type: null,
        showForm: () => false,
      },
    },
    "SLOW TRACK": {
      ASSESSMENT_MADE: {
        type: null,
        showForm: () => false,
      },
    },
  },
};
